import { transport } from 'config/transport';

export function callApiGetCongDoanReportForAllCongDoan(academicYear, abroadOnly = false) {
    return transport.get(`/trunguong/report/congdoan/data-annually`, { params: { academicYear, abroadOnly } });
}
